import { useQuery } from '@tanstack/react-query';
import { opportunityApiConnect } from '../../lib/api/opportunityApi.connect';
/** Resolve a morgans notice/opportunity by notice_id for chip labels. */ export function useMorgansNotice(noticeId) {
    return useQuery({
        queryKey: [
            'morgans-notice',
            noticeId
        ],
        enabled: Boolean(noticeId),
        queryFn: ()=>opportunityApiConnect.getOpportunity(noticeId ?? ''),
        retry: false
    });
}
